import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@vimaana/ui";

import type { KundeAkte } from "../lib/kundeAktivitaet";

/** Chronik eines Kunden (nur gelesen). Eigene Notizen: `useNotizen({ kunde_id })`. */
export function useKundeAkte(kundeId?: string) {
  return useQuery<KundeAkte>({
    queryKey: ["kunde-akte", kundeId],
    queryFn: () => apiGet<KundeAkte>(`/api/kontor/kunde/${kundeId}/aktivitaet`),
    enabled: !!kundeId,
    staleTime: 30_000,
  });
}
